import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  apiError,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getCustomCategoriesByConsultantId = (consultantId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/categoria-personalizzata/consulente/${consultantId}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: 'Errore durante il caricamento dei dati: categorie non trovate.',
    }),
  );
};

export const createCustomCategory = (requestBody) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = '/api/categoria-personalizzata';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Registrazione della categoria non riuscita: dati non corretti.',
      404: 'Registrazione della categoria non riuscita: dati non corretti.',
    }),
  );
};

export const deleteCustomCategory = (id) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/categoria-personalizzata/${id}`;
  const URL = BASE_URL + PATH;
  // The server's sentence wins, which is the point of the detailed wrapper: the
  // locals below are the fallback for a status that carries none.
  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'DELETE',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: 'Eliminazione non riuscita: categoria non trovata.',
    }),
  );
};
